import type AlertModal from "@/components/app/modal/Alert.vue";
import type { AlertModalOptions } from "@/utils/types/alert";

type AlertModalInstance = InstanceType<typeof AlertModal>;

interface AlertService {
  register: (instance: AlertModalInstance | null) => void;
  show: (options: AlertModalOptions) => void;
  hide: () => void;
}

const createAlert = (): AlertService => {
  const alertModalRef = shallowRef<AlertModalInstance | null>(null);

  return {
    register(instance: AlertModalInstance | null) {
      alertModalRef.value = instance;
    },
    show(options: AlertModalOptions) {
      alertModalRef.value?.show(options);
    },
    hide() {
      alertModalRef.value?.hide();
    },
  };
};

export default defineNuxtPlugin(() => {
  const alert = createAlert();

  return {
    provide: {
      alert,
    },
  };
});

declare module "#app" {
  interface NuxtApp {
    $alert: AlertService;
  }
}

declare module "vue" {
  interface ComponentCustomProperties {
    $alert: AlertService;
  }
}
